/**
 * A day, written the way this application writes days: 2025-07-03.
 *
 * One notation, everywhere - the table, the editor, the reports. There used to
 * be three: `3/7/2025` in a cell, `03.07.2025` in the picker below it, and
 * `2025-07-03` in the request that carried it. Three readings of one day is how
 * a reader ends up unsure which number is the month, and it is also how the
 * application disagreed with itself on screen.
 *
 * ISO is the one the API already speaks, so this stops being a conversion at
 * all: a date-only string is returned UNCHANGED, because it is already right.
 *
 * **A date-only string never becomes a `Date`.** `new Date("2025-07-03")` is
 * parsed as midnight UTC - that is what the language specifies for the
 * date-only form - so `getDate()` in any browser west of Greenwich answers the
 * 2nd. Splitting the string is not a shortcut here; it is the only reading that
 * cannot be wrong, because a date has no instant to place and no zone to place
 * it in.
 *
 * The other two shapes still go through `Date`, and should:
 *
 *   - a full timestamp from the API, like `users.last_login`. That IS an
 *     instant, and showing it in the reader's own time is right.
 *   - a `Date` object, from an editor that has not been submitted yet.
 *
 * This used to live in five copies - `shortDate` here plus four `dateFormater`
 * in the column and report files - which is four places to fix a defect and
 * three to forget.
 */
const DATE_ONLY = /^(\d{4})-(\d{2})-(\d{2})$/;

const pad = n => String(n).padStart(2, '0');

const localDay = d =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const shortDate = date => {
  if (!date) {
    return "";
  }
  if (typeof date === 'string') {
    if (DATE_ONLY.test(date)) {
      return date;
    }
    const d = new Date(date);
    return isNaN(d.getDate()) ? undefined : localDay(d);
  }
  return localDay(date);
};


export {
  shortDate
};
